module.exports = __webpack_public_path__ + "img/chinamove.ad1a1db5.png";